import Vue from 'vue'

Vue.filter('formatDate', function (value) {
  if (value) {
    var result = new Date(value)
    return result.toString('yyyy/MM/dd')
  }
})



// WEBPACK FOOTER //
// ./src/filters/date.js